module.exports = __webpack_public_path__ + "static/media/3_col_11.bddf340d.jpg";